import React,{useState,useEffect} from 'react'
import './ToursSlider.scss'

import 'swiper/css';
import 'swiper/css/navigation';
import { Swiper, SwiperSlide } from 'swiper/react';


import { Navigation } from 'swiper/modules';
import { Link } from 'react-router-dom'
import tours from "./toursData"



function ToursSlider({hotels}) {
  
const[selectedSlide,setSelectedSlide]=useState(hotels?hotels[0].id:tours[0].id)
  const [matches, setMatches] = useState(
    window.matchMedia("(max-width: 680px)").matches
  )
  
  useEffect(() => {
    window
    .matchMedia("(max-width: 680px)")
    .addEventListener('change', e => setMatches( e.matches ));
  }, []);


  if(hotels){
    return (

      <div className='tours-slider-box' >
        
      <Swiper navigation={matches?false:true}  spaceBetween={30}  slidesPerView={matches? 1.2 : 2} modules={[Navigation]}  centeredSlides={true}  onSlideChange={(e)=>setSelectedSlide(hotels[e.activeIndex].id)}   className="mySwiper">
      <div className="slide-info">
        <h1>{hotels[selectedSlide].cover_name}</h1>
        <p></p>
        <Link to='/hotelDetails' state={{ hotel: hotels.find((el)=>el.id===selectedSlide) }}><button className='detail-btn' >Подробнее</button></Link>
      </div>
        {hotels.map((hotel,index)=>(
          <SwiperSlide  key={index}>
            
            <img src={hotel.cover_image} alt="" draggable='false'/>
         
          </SwiperSlide>
          ))}
        
      
    </Swiper>
    </div>
      
    )
    
  }else{
    return (

      <div className='tours-slider-box'>
        
      <Swiper navigation={matches?false:true}  spaceBetween={30}   slidesPerView={matches? 1.2 : 2} modules={[Navigation]}  centeredSlides={true}  onSlideChange={(e)=>setSelectedSlide(tours[e.activeIndex].id)}   className="mySwiper">
      <div className="slide-info">
        <h1>{tours[selectedSlide].tour_title}</h1>
        <p>{tours[selectedSlide].cover_description}</p>
        <Link to='/details' state={{ tour: tours.find((el)=>el.id===selectedSlide) }}><button className='detail-btn' >Подробнее</button></Link>
      </div>
        {tours.map((tour,index)=>(
          <SwiperSlide key={index}>
            
            <img src={tour.cover_url} alt="" />
         
          </SwiperSlide>
          ))}
        
      
    </Swiper>
    </div>
      
    )
  }
  
}

export default ToursSlider
